export default {
  available_campaigns: undefined,
  available_formats: undefined,
  available_templates: undefined,
  available_themes: undefined,

  filtered_formats: undefined,
  filtered_templates: undefined,
  filtered_themes: undefined,

  template: undefined,
  theme: undefined,
  
  campaign: undefined,
  campaign_id: undefined,

  templateImages: [],

  templateColors: [],

  isHybrid: false,
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/selector/state.js